import { useTranslation } from '@mint-lib/i18n';

import { DataFileFormats } from '../../api/types.js';
import {
  useDataFileFormatsOptions,
  useUpdateDataFileFormats,
} from '../../queries/index.js';
import { getDateFormatLabel } from '../../utils/index.js';
import { Select } from '../atoms/Select.jsx';

type SelectFormatsFieldsProps = {
  dataFileId: string;
  isValuesLoading: boolean;
  values: DataFileFormats;
};

export const SelectFormatsFields = ({
  dataFileId,
  isValuesLoading,
  values,
}: SelectFormatsFieldsProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const { data: tableHeadersFormatsMeta, isLoading: isOptionsLoading } =
    useDataFileFormatsOptions({
      throwOnError: true,
    });

  const isLoading = isOptionsLoading || isValuesLoading;

  const { mutate: updateDataFileFormats } =
    useUpdateDataFileFormats(dataFileId);

  const changeFormat = (fieldName: string, value: string) => {
    const payload = {
      ...values,
      [fieldName]: value,
    };
    updateDataFileFormats({
      id: dataFileId,
      payload,
    });
  };

  const dateFormatsOptions = tableHeadersFormatsMeta.dateOrders.map(
    (value) => ({
      value,
      label: getDateFormatLabel(t, value),
    }),
  );

  const numberFormatsOptions = tableHeadersFormatsMeta.numberFormats.map(
    (value) => ({
      value,
      label: value,
    }),
  );
  return (
    <div className="flex flex-nowrap gap-2">
      <Select
        label={t('Date format*')}
        placeholder={t('Select')}
        inputValue={getDateFormatLabel(t, values.dateOrder ?? '')}
        options={dateFormatsOptions}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={(selectedOption) =>
          changeFormat('dateOrder', selectedOption.value)
        }
        isLoading={isLoading}
        size="small"
        className="min-w-[200px]"
      />
      <Select
        label={t('Number format')}
        placeholder={t('Select')}
        inputValue={values.numberFormat}
        options={numberFormatsOptions}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        onChange={(selectedOption) =>
          changeFormat('numberFormat', selectedOption.value)
        }
        isLoading={isLoading}
        size="small"
        className="min-w-[160px]"
      />
    </div>
  );
};
